import { useState } from 'react'
import Popover from './Popover'

const ListActions = ({ className, slug }) => {
  const [showPopover, setShowPopover] = useState(false)

  const handleBlur = () => setShowPopover(false)
  const handlePopoverToggle = () => setShowPopover(!showPopover)
  const handleCopy = () => setShowPopover(false)

  return (
    <div className={`gray f7 mw7 relative w-100 ${className}`}>
      <a className="link blue pointer underline" onClick={handlePopoverToggle}>
        Embed
      </a>{' '}
      list
      {showPopover && (
        <Popover onBlur={handleBlur} onCopy={handleCopy} slug={slug} />
      )}
    </div>
  )
}

export default ListActions
